import { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Stack,
  Table,
  Avatar,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
import "../../../Style/pagestyle.scss";
import EmptyData from "../../Include/EmptyData/EmptyData";
// import InputScore from "./InputScore";
import LoadingPage from "../../../Utils/LoadingPage";
import useGetStudentForExamTable from "../../../Hooks/useGetStudentForExamTable";
import { AuthContext } from "../../../Context/AuthContext";
import { SelectExamType } from "../../Include/DynamicSelect/DynamicSelect";
// import { formatNumbertoLocaleString } from "../../Include/DynamicFunction";
import { ButtonCreate, SearchTextField } from "../../../Utils/Component";
import ExamForm from "./ExamForm";
import ExamRow from "./ExamRow";
import useWithDimension from "../../../Hooks/useWithDimension";
//
export default function ExamScore({ classId }) {
  // Change Language
  const { language, t } = useContext(AuthContext);
  const { width } = useWithDimension();
  const [keyword, setKeyword] = useState("");
  const [examType, setExamType] = useState({ id: "", title: "" });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { tableData, loading, refetch } = useGetStudentForExamTable({
    keyword: keyword,
    classId: classId || "",
    examTypeId: examType?.id || "",
  });

  // console.log("tableData::", tableData)

  const handleSearch = (e) => {
    setKeyword(e.target.value);
  };

  const studentSelectId = window.localStorage.getItem("ClickStudentId");

  return (
    <div>
      <Box sx={{ marginTop: "10px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <SelectExamType
              classId={classId}
              value={examType}
              className={"text-field"}
              onChange={(val) => setExamType(val)}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={6} xl={8}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <ExamForm
                classId={classId}
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle={"Create"}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_student")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="6%">
                  {t("thead_gender")}
                </TableCell>

                {/* <TableCell className={t("class-name-header-title")} width="60%">
                  {t("thead_subject")}
                  <Stack direction="row" alignItems="center" spacing={1.2}>
                    {tableData &&
                      tableData[0]?.subjectScoreData?.map((e, index) => (
                        <Typography
                          key={index}
                          width={`${
                            100 / tableData[0]?.subjectScoreData.length
                          }%`}
                          sx={{ textAlign: "center" }}
                        >
                          {language === "en"
                            ? e?.subjectId?.enName
                            : e?.subjectId?.khName}
                        </Typography>
                      ))}
                  </Stack>
                </TableCell> */}

                <TableCell
                  className={t("class-name-header-title-end")}
                  width="75%"
                >
                  <Stack direction="row" sx={{ width: "100%" }}>
                    <Typography sx={{ width: "20%" }}>
                      {t("thead_subject")}
                    </Typography>
                    <Typography sx={{ width: "50%" }}>
                      {t("thead_exercise")}
                    </Typography>
                    <Typography sx={{ width: "10%" }}>
                      {t("thead_score")}
                    </Typography>
                    <Typography
                      sx={{ width: "20%", bgcolor: "grdy" }}
                    ></Typography>
                  </Stack>
                </TableCell>

                {/* <TableCell className={t("class-name-header-title")} width="30%">
                  {t("thead_exercise")}
                </TableCell>
                
                <TableCell className={t("class-name-header-title")} width="10%">
                  {t("thead_score")}
                </TableCell> */}

                {/* <TableCell
                  width="7%"
                  align="center"
                  className={t("class-name-header-title")}
                >
                  {t("thead_total")}
                </TableCell> */}

                {/* <TableCell
                  width="7%"
                  align="center"
                  className={t("class-name-header-title-end")}
                >
                  {t("thead_average")}
                </TableCell> */}
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow
                          className={
                            studentSelectId === row._id
                              ? "body-row onclick-student"
                              : "body-row"
                          }
                          sx={{ paddingY: 0 }}
                          key={index}
                        >
                          <TableCell
                            className="body-cell-start"
                            sx={{ paddingY: 0 }}
                          >
                            {index + 1}
                          </TableCell>

                          <TableCell className="body-cell" sx={{ paddingY: 0 }}>
                            <Stack direction="row" spacing={1.4}>
                              <Stack direction="column" justifyContent="center">
                                <Avatar
                                  sx={{ width: 40, height: 40 }}
                                  alt={row?.studentId?.studentName}
                                  src={row?.studentId?.profile}
                                />
                              </Stack>
                              <Stack direction="column" justifyContent="center">
                                <Typography className="student-name">
                                  {row?.studentId?.familyName +
                                    " " +
                                    row?.studentId?.studentName}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.studentId?.gender === "Male"
                              ? t("thead_male")
                              : t("thead_female")}
                          </TableCell>

                          <TableCell
                            className="body-cell-end"
                            sx={{ paddingY: 1 }}
                          >
                            <Stack direction="column" spacing={0}>
                              {row?.subjectScoreData?.map((e, subIndex) => {
                                return (
                                  <div
                                    key={subIndex}
                                    style={{
                                      borderTop:
                                        subIndex === 0
                                          ? "none"
                                          : "1px solid #e4e6e7ff",
                                      padding: "5px 0px",
                                    }}
                                  >
                                    <ExamRow
                                      data={e}
                                      row={row}
                                      classId={classId}
                                      setRefetch={refetch}
                                      language={language}
                                    />
                                  </div>
                                );
                              })}
                            </Stack>
                            {/* <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1.2}
                            >
                              {row?.subjectScoreData?.map((e, subIndex) => (
                                <Box
                                  key={subIndex}
                                  width={`${
                                    100 / tableData[0]?.subjectScoreData.length
                                  }%`}
                                >
                                  <InputScore
                                    student={row}
                                    editData={e}
                                    setRefetch={refetch}
                                    examTypeId={examType?.id}
                                  />
                                </Box>
                              ))}
                            </Stack> */}
                          </TableCell>
                          {/* 
                          <TableCell
                            sx={{
                              color: "#044292",
                              paddingY: 0,
                              fontWeight: "bold",
                            }}
                            align="center"
                            className="body-cell"
                          >
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                color: "#131870",
                              }}
                            >
                              {formatNumbertoLocaleString(row?.totalScore)}
                            </Typography>
                          </TableCell>

                          <TableCell align="center" className="body-cell-end">
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                color: "#131870",
                              }}
                            >
                              {formatNumbertoLocaleString(row?.average)}
                            </Typography>
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
